<template>
  <div>
    <div class="flex items-center">
      <span v-if="item.unit" class="text-center text-sm">
        VE ({{item.unit}} Stk.)
      </span>
      <VueNumberInput
        v-model="quantity"
        size="small"
        :class="{ 'opacity-30': isNotOrderable }"
        :disabled="isNotOrderable"
        controls
        :step="item.unit ? item.unit : 1"
        placeholder="0"
        :min="0"
        :max="atypicalQuantity"
        class="w-32 ml-4" />
      <span class="ml-2 text-sm">Stück</span>
    </div>

    <div v-if="quantity >= (atypicalQuantity - 20)" class="text-grey-600 my-2 text-xs text-right max-w-xs">
      Wenn Sie mehr als <b>{{ atypicalQuantity }} Einheiten</b> bestellen möchten, melden Sie sich bei unserem Kundenservice.
    </div>
    <div v-if="!isQuantityValid" class="text-red-600 my-2 text-sm text-right">
      Bitte beachten Sie die VE von {{ item.unit }}. <br>
      <button
        v-if="recommendedQuantity"
        class="underline"
        @click.prevent="() => (quantity = recommendedQuantity)">
        Auf {{ recommendedQuantity }} ändern
      </button>
    </div>
    <button
      v-if="!inChangeLog && (quantity > 0 || (quantity === 0 && savedQuantity > 0))"
      :disabled="!isQuantityValid || savedQuantity === quantity"
      class="button-primary"
      @click.prevent="onPressButton">
      <Spinner v-if="saving" class="text-white" />
      <span v-if="savedQuantity > 0 && quantity === 0">Produkt entfernen</span>
      <span v-else-if="savedQuantity > 0 && quantity > 0">Bestellung anpassen</span>
      <span v-else>der Bestellung hinzufügen</span>
    </button>

    <button
      v-if="inChangeLog"
      :disabled="!isQuantityValid"
      class="button-primary"
      @click.prevent="onPressButton">
      <Spinner v-if="saving" class="text-white" />
      <span v-if="savedQuantity > 0 && quantity === 0">Produkt entfernen</span>
      <span v-else-if="savedQuantity > 0 && quantity > 0">Bestellung anpassen</span>
      <span v-else>Bestellung ändern</span>
    </button>
  </div>
</template>

<script>
import VueNumberInput from '@chenfengyuan/vue-number-input'

import Spinner from '@/Components/Spinner'

export default {
  name: 'ProductQuantity',
  components: { VueNumberInput, Spinner },
  props: {
    item: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: false,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    },
    inChangeLog: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    quantity: 0,
    savedQuantity: 0,
  }),

  computed: {
    isQuantityValid() {
      if (this.item.unit && this.item.unit > 0) {
        return this.quantity % this.item.unit === 0
      }

      return true
    },

    recommendedQuantity() {
      return this.isQuantityValid
            ? this.quantity
            : Math.ceil(this.quantity / this.item.unit) * this.item.unit
    },

    isNotOrderable() {
      return !this.item.orderable
    },

    atypicalQuantity() {
      return this.item.primary_category?.atypical_quantity ?? 400
    }
  },

  watch: {
    order: function() {
      this.updateQuantityBasedOnOrder()
    }
  },

  created () {
    this.updateQuantityBasedOnOrder()
  },

  methods: {
    updateQuantityBasedOnOrder() {
      if (!this.order || !this.order.products) {
        this.savedQuantity = 0
        return false
      }

      this.order.products.map(({ id, pivot: { quantity } }) => {
        if (this.item.id === id) {
          this.savedQuantity = quantity
          this.quantity = quantity
        }
      })
    },

    onPressButton () {
      this.$emit('changeQuantity', this.quantity)
    },
  }
}
</script>
